"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import taskMap from "@/configuration/taskMap";
import API from "@ym-framework/api-utils";
import OSS from "ali-oss";
const UUID = require("uuid");
export class UploadTask {
  constructor(file, id, type) {
    // 类型
    this.type = "shop";
    // 文件路径
    this.path = "";
    // ossid
    this.ossId = "";
    // 更新时间
    this.updateTime = 0;
    this.fileType = "local";
    this.file = file;
    this.progress = 0;
    this.state = taskMap.await;
    this.orderId = id;
    this.name = file.name;
    this.keyId = `${Math.random()}${Date.now()}${Math.random()}`;
    this.updateTime = Date.now().valueOf();
    this.speed = "0";
    this.type = type;
  }
}
export class UploadPayPalManagerWrap {
  //上传参数
  constructor() {
    //当前oss实例
    this.queueTask = [];
    //当前传输任务
    this.historyTaskSuccess = [];
    //历史传输成功
    this.historyTaskError = [];
    //历史传输失败
    this.beUpload = false;
    //是否正在上传中
    this.refreshFileList = false;
    //中止检查点
    this.isUploadSuccessPayPal = false;
    // 是否成功上传
    this.payPalParam = null;
    this.queueTask = [];
    this.historyTaskSuccess = [];
    this.historyTaskError = [];
    this.beUpload = false;
  }
  //总任务数
  get allTaskLen() {
    return this.historyTaskSuccess.length + this.queueTask.length + this.historyTaskError.length;
  }
  //队列任务数
  get queueTaskLen() {
    return this.queueTask.length;
  }
  //失败任务数
  get TaskErrorLen() {
    return this.historyTaskError.length;
  }
  //添加任务
  add(tasks, param) {
    this.payPalParam = param;
    console.log("\u6DFB\u52A0\u4E86\u4EFB\u52A1\uFF1A" + tasks[0].orderId);
    console.log(
      this.queueTask.length,
      this.historyTaskSuccess.length,
      "\u961F\u5217\u6570\u91CF"
    );
    this.queueTask.unshift(...tasks);
    if (!this.beUpload) {
      this.start();
    }
  }
  //启动任务
  start() {
    return __async(this, null, function* () {
      console.log("\u4EFB\u52A1\u542F\u52A8");
      if (this.queueTask.length === 0) {
        this.beUpload = false;
        this.refreshFileList = true;
        return false;
      }
      this.beUpload = true;
      this.refreshFileList = false;
      this.currentTask = this.queueTask[0];
      if (this.currentTask.state !== taskMap.await) {
        this.uploadError();
        return false;
      }
      this.currentTask.state = taskMap.running;
      this.preUpload();
    });
  }
  //传输成功
  uploadSuccess() {
    return __async(this, null, function* () {
      yield this.noticePayPalUpload();
      console.log("\u4E0A\u4F20\u5B8C\u6210");
      this.currentTask.state = taskMap.success;
      this.isUploadSuccessPayPal = true;
      this.queueTask.shift();
      this.historyTaskSuccess.unshift(this.currentTask);
      console.log(this.historyTaskSuccess, "\u5386\u53F2\u6210\u529F");
      this.start();
    });
  }
  //传输失败
  uploadError() {
    this.currentTask.state = taskMap.error;
    this.historyTaskError.unshift(this.currentTask);
    this.start();
  }
  //预上传请求
  preUpload() {
    return __async(this, null, function* () {
      yield this.getTmpAuth();
      yield this.uploadToAliOss(this.tmpAuth);
    });
  }
  //任务开始传输
  uploadToAliOss(data) {
    return __async(this, null, function* () {
      var _a;
      console.log(data, "\u4E34\u65F6\u6388\u6743\u6570\u636E");
      try {
        this.client = new OSS({
          region: "oss-cn-beijing",
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        let random = UUID.v4();
        this.currentTask.path = data.path + "/" + random;
        this.currentTask.ossId = data.id;
        let percent = ((_a = this.currentTask) == null ? void 0 : _a.file.size) / 100;
        let time = Date.now();
        let lastProgress = 0;
        yield this.client.multipartUpload(
          data.path + "/" + random,
          this.currentTask.file,
          {
            progress: (p, cpt) => {
              this.abortCheckpoint = cpt;
              this.currentTask.progress = p * 100;
              if (Date.now() - time >= 800) {
                this.currentTask.speed = this.transform(
                  +(p * 100 - lastProgress).toFixed(2) * percent
                );
                time = Date.now();
                lastProgress = p * 100;
              }
            }
          }
        );
        this.uploadSuccess();
      } catch (error) {
        console.log("\u4E0A\u4F20\u5931\u8D25", error);
        this.uploadError();
      }
    });
  }
  // 获取临时授权
  getTmpAuth() {
    return __async(this, null, function* () {
      var _a, _b;
      console.log("\u83B7\u53D6\u4E34\u65F6\u6388\u6743", (_a = this.currentTask) == null ? void 0 : _a.orderId);
      try {
        const response = yield API.get("api://base.auth/api/v7/file/sts", {
          params: {
            type: "order",
            id: (_b = this.currentTask) == null ? void 0 : _b.orderId
          }
        });
        this.tmpAuth = response.data.data;
      } catch (error) {
        this.currentTask.message = error.response.data.errors.datas[0].message;
        this.uploadError();
      }
    });
  }
  //大小转换
  transform(byte) {
    if (byte > 1024 * 1024) {
      return `${(byte / 1024 / 1024).toFixed(2)}MB`;
    }
    if (byte > 1024) {
      return `${(byte / 1024).toFixed(2)}KB`;
    }
    return `${byte.toFixed(2)}B`;
  }
  noticePayPalUpload() {
    return __async(this, null, function* () {
      if (this.currentTask.message !== "\u5DF2\u53D6\u6D88") {
        yield this.uploadToPayPal();
      }
    });
  }
  // 上传到PayPal的截图
  uploadToPayPal() {
    return __async(this, null, function* () {
      var _a;
      console.log("\u4E0A\u4F20\u5230PayPal");
      try {
        const _response = yield API.post(
          `api://base.auth/api/v8/orders/${(_a = this.currentTask) == null ? void 0 : _a.orderId}/files`,
          {
            file_uid: this.currentTask.ossId,
            // 单个传
            files: [
              {
                file_path: this.currentTask.path,
                file_real_name: this.currentTask.file.name
              }
            ]
          }
        );
        this.payPalParam.onSuccess(_response, this.currentTask.file);
      } catch (error) {
      }
    });
  }
  // 清除任务队列
  clearQueue() {
    console.log("\u6E05\u9664\u4EFB\u52A1\u961F\u5217");
    this.queueTask = [];
  }
}
